import React from 'react';
import { items } from '../assets';
import './ProfileList.scss';

const ProfileList = () => {
  // Get Brady O., Jordan P., and Mary S. from the items array
  const selectedNames = ['Brady O.', 'Jordan P.', 'Mary S.'];
  const profileList = items.filter(item => selectedNames.includes(item.name));

  return (
    <div className="profileList">
      {profileList.map((profile, index) => (
        <div key={profile.key} className="profileList-card">
          <div className="profileList-header">
            <div className="profileList-image">
              <img src={profile.image} alt={profile.name} />
            </div>
            <div className="profileList-info">
              <div className="profileList-name">{profile.name}</div>
              <div className="profileList-location">{profile.location}</div>
              <div className="profileList-jobs">
                <span className="jobs-number">{profile.workedJobs}</span>
                <span className="jobs-text">Jobs Worked</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProfileList;
